import { useState, useEffect } from "react";
import { Button } from "./ui/button";
import { Menu, X } from "lucide-react";
import logo from "../assets/logo.png";

const LINKS = [
  { label: "Services", href: "#services" },
  { label: "Hospitals", href: "#hospitals" },
  { label: "How it works", href: "#how" },
  { label: "Our promise", href: "#manifesto" },
  { label: "FAQ", href: "#faq" },
  { label: "Join us", href: "#associates" },
  { label: "Contact", href: "#contact" },
];

export const Navbar = ({ onBook }) => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-colors duration-500 ${
        scrolled
          ? "bg-brand-cream/80 backdrop-blur-xl border-b border-border/50"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-20 flex items-center justify-between">
        <a
          href="#top"
          data-testid="brand-logo"
          className="font-serif text-2xl tracking-tight text-brand-ink flex items-center gap-2"
        >
          <span>Eldercare<span className="text-brand">24</span></span>
          <img src={logo} alt="ElderCare24 — elderly couple in a heart" className="h-9 w-auto" />
        </a>

        <nav className="hidden md:flex items-center gap-10">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-${l.label.split(" ")[0].toLowerCase()}`}
              className="text-sm font-medium text-brand-ink/70 hover:text-brand transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <Button
            data-testid="nav-book-btn"
            onClick={onBook}
            className="hidden sm:inline-flex rounded-full bg-brand hover:bg-brand-hover text-white px-6 h-11 transition-transform active:scale-95"
          >
            Request a visit
          </Button>
          <button
            data-testid="mobile-menu-toggle"
            className="md:hidden text-brand-ink"
            onClick={() => setOpen((o) => !o)}
          >
            {open ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="md:hidden bg-brand-cream border-b border-border px-6 py-6 flex flex-col gap-4">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              className="text-base font-medium text-brand-ink"
            >
              {l.label}
            </a>
          ))}
          <Button
            data-testid="mobile-book-btn"
            onClick={() => {
              setOpen(false);
              onBook();
            }}
            className="rounded-full bg-brand hover:bg-brand-hover text-white"
          >
            Request a visit
          </Button>
        </div>
      )}
    </header>
  );
};
